module.exports = __webpack_public_path__ + "static/media/Defense.11c2c390.svg";